import {
  STORAGE,
  SIGN_OUT,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function storage(state = initialState, action) {
  switch (action.type) {
    case STORAGE.handlers.fetch:
    case STORAGE.handlers.update:
    case STORAGE.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case STORAGE.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    case SIGN_OUT:
      return initialState;
    default:
      return state;
  }
}
